import styled from "@emotion/styled";
import { titleH1 } from "../Common";

export const SectionTitle = styled(titleH1)`
  margin-bottom: ${({ theme }) => theme.extend.getSpacing(4)};
`;
